export default{
    lang:"pt",
    fontFamily:"en-font-family",
    fontFamilyTitle:"en-font-family-title",
    requestLang:"en_US",
    type: "en",
}